import React from "react";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const FeaturedSection = () => {
  const features = [
    {
      id: 1,
      icon: "Award",
      title: "100% Halal Certified",
      description:
        "All our ingredients are certified halal, ensuring quality and trust in every bite",
      color: "text-trust-green",
    },
    {
      id: 2,
      icon: "Leaf",
      title: "Fresh Daily Preparation",
      description:
        "Made fresh every day with locally sourced ingredients and authentic recipes",
      color: "text-primary",
    },
    {
      id: 3,
      icon: "Users",
      title: "Community Driven",
      description:
        "A welcoming space where diverse communities gather around shared food experiences",
      color: "text-accent",
    },
    {
      id: 4,
      icon: "Clock",
      title: "Quick Service",
      description:
        "Fast-casual dining without compromising on taste, quality, or authenticity",
      color: "text-brand-mustard",
    },
  ];

  const featuredItems = [
    {
      id: 1,
      name: "Classic Street Tacos",
      image: "https://images.unsplash.com/photo-1734773074866-507cc8d3b99c",
      alt: "Three authentic street tacos with seasoned beef, fresh cilantro, diced white onions, lime wedges on corn tortillas served on rustic wooden board",
      price: "₹149",
      description: "Authentic street-style tacos with your choice of protein",
      badge: "Bestseller",
      spiceLevel: 2,
    },
    {
      id: 2,
      name: "Loaded Nachos Supreme",
      image: "https://images.unsplash.com/photo-1695886135860-2fe067db2fb8",
      alt: "Colorful plate of crispy tortilla chips loaded with melted cheese, jalapeños, sour cream, guacamole, black beans, and fresh tomatoes",
      price: "₹199",
      description: "Crispy nachos loaded with cheese, jalapeños, and toppings",
      badge: "Popular",
      spiceLevel: 3,
    },
    {
      id: 3,
      name: "Burrito Bowl",
      image: "https://images.unsplash.com/photo-1566740933449-11e38b77e6e5",
      alt: "Vibrant burrito bowl with seasoned rice, black beans, grilled chicken, corn salsa, lettuce, cheese, sour cream, and lime wedge in white bowl",
      price: "₹179",
      description: "Customizable bowl with rice, beans, and fresh toppings",
      badge: "Healthy",
      spiceLevel: 1,
    },
  ];

  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Features Grid */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-foreground mb-4">
              Why Choose Taco Street?
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Experience the perfect blend of authentic flavors, quality
              ingredients, and community spirit
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features?.map((feature) => (
              <div
                key={feature?.id}
                className="bg-card rounded-xl p-6 text-center hover:shadow-lg transition-all duration-300 animate-fade-in"
              >
                <div
                  className={`w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4 ${feature?.color}`}
                >
                  <Icon name={feature?.icon} size={32} />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">
                  {feature?.title}
                </h3>
                <p className="text-muted-foreground">{feature?.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Featured Menu Items */}
        <div>
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-foreground mb-4">
              Featured Favorites
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Discover our most loved dishes that keep customers coming back for
              more
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {featuredItems?.map((item) => (
              <div
                key={item?.id}
                className="bg-card rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 group animate-slide-up"
              >
                <div className="relative h-64 overflow-hidden">
                  <Image
                    src={item?.image}
                    alt={item?.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />

                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-accent text-accent-foreground text-sm font-semibold rounded-full">
                      {item?.badge}
                    </span>
                  </div>
                  <div className="absolute top-4 right-4 flex gap-1">
                    {[...Array(3)]?.map((_, index) => (
                      <Icon
                        key={index}
                        name="Flame"
                        size={16}
                        color={index < item?.spiceLevel ? "#E85D04" : "#E5DDD5"}
                      />
                    ))}
                  </div>
                </div>

                {/* <div className="p-6">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-xl font-semibold text-foreground">
                      {item?.name}
                    </h3>
                    <span className="text-xl font-bold text-primary">
                      {item?.price}
                    </span>
                  </div>
                  <p className="text-muted-foreground mb-4">
                    {item?.description}
                  </p>
                  <Button
                  variant="default"
                  size="default"
                  iconName="Plus"
                  iconPosition="left"
                  fullWidth>

                    Add to Cart
                  </Button>
                </div> */}
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Button
              variant="outline"
              size="lg"
              iconName="ArrowRight"
              iconPosition="right"
            >
              View Full Menu
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;
